import React from "react";
import { Routes, Route } from "react-router-dom";
import usePageTitle from "../hooks/usePageTitle";

//  for public pages
import Login from "../components/Login";
import Error from "../components/Error";
import Register from "../components/Register";

// for SuperAdmin
import ManagePage from "../Pages/SuperAdmin/ManagePage";
import HaribhaktTable from "../Pages/SuperAdmin/Haribhakt/HaribhaktTable";
import AddHaribhakt from "../Pages/SuperAdmin/Haribhakt/AddHaribhakt";
import UpdateHaribhakt from "../Pages/SuperAdmin/Haribhakt/UpdateHaribhakt";
import AdminTablePage from "../Pages/SuperAdmin/Admin/AdminTablePage";
import AddAdmin from "../Pages/SuperAdmin/Admin/AddAdmin";
import UpdateAdmin from "../Pages/SuperAdmin/Admin/UpdateAdmin";
import AttendanceTable from "../Pages/SuperAdmin/AttendanceTable";
import MandalTable from "../Pages/SuperAdmin/MandalDetails/MandalTable";
import AddMandal from "../Pages/SuperAdmin/MandalDetails/AddMandal";
import UpdateMandal from "../Pages/SuperAdmin/MandalDetails/UpdateMandal";
import MandalInfo from "../Pages/SuperAdmin/MandalInfo/MandalInfo";
import ReportTable from "../Pages/SuperAdmin/AddReport/ReportTable";
import AddReport from "../Pages/SuperAdmin/AddReport/AddReport ";
import UpdateReport from "../Pages/SuperAdmin/AddReport/UpdateReport";
import ParaSabhaReportTable from "../Pages/SuperAdmin/ParaSabhaReport/ParaSabhaReportTable";
import ManageGroup from "../Pages/SuperAdmin/ManageGroup/ManageGroup";
import AddGroup from "../Pages/SuperAdmin/ManageGroup/AddGroup";
import UpdateGroup from "../Pages/SuperAdmin/ManageGroup/UpdateGroup";
import DeletedHaribhakt from "../Pages/SuperAdmin/DeletedHaribhakt";

// for Admin
import AdminDashboard from "../Pages/Admin/AdminDashboard";
import AdminMandalTable from "../Pages/Admin/MandalDetails/MandalTable";
import AdminAddMandal from "../Pages/Admin/MandalDetails/AddMandal";
import AdminUpdateMandal from "../Pages/Admin/MandalDetails/UpdateMandal";
import AdminMandalInfo from "../Pages/Admin/MandalDetails/MandalInfo";
import AdminHaribhaktTable from "../Pages/Admin/Haribhakt/HariBhaktTable";
import AdminAddHaribhakt from "../Pages/Admin/Haribhakt/AddHariBhakt";
import AdminUpdateHaribhakt from "../Pages/Admin/Haribhakt/UpdateHariBhakt";
import AdminAttendanceTable from "../Pages/Admin/AttendanceTable";
import AdminReportTable from "../Pages/Admin/AddReport/ReportTable";
import AdminAddReport from "../Pages/Admin/AddReport/AddReport";
import AdminUpdateReport from "../Pages/Admin/AddReport/UpdateReport";
import AdminParaSabhaReportTable from "../Pages/Admin/ParaSabhaReport/ParaSabhaReportTable";
import AdminManageGroup from "../Pages/Admin/ManageGroup/ManageGroup";
import AdminAddGroup from "../Pages/Admin/ManageGroup/AddGroup";
import AdminUpdateGroup from "../Pages/Admin/ManageGroup/UpdateGroup";

// for MandalAdmin
import MandalAdminDashboard from "../Pages/MandalAdmin/MandalAdminDashboard";
import MandalAdminMandalTable from "../Pages/MandalAdmin/MandalDetails/MandalTable";
import MandalAdminMandalInfo from "../Pages/MandalAdmin/MandalInfo/MandalInfo"
import MandalAdminHaribhaktTable from "../Pages/MandalAdmin/Haribhakt/HaribhaktTable"
import MandalAdminAddHaribhakt from "../Pages/MandalAdmin/Haribhakt/AddHaribhakt"
import MandalAdminUpdateHaribhakt from "../Pages/MandalAdmin/Haribhakt/UpdateHaribhakt"
import MandalAdminAttendanceTable from "../Pages/MandalAdmin/AttendanceTable"
import MandalAdminUpdateMandal from "../Pages/MandalAdmin/MandalDetails/UpdateMandal"
import MandalAdminAddReport from "../Pages/MandalAdmin/AddReport/AddReport";
import MandalAdminReportTable from "../Pages/MandalAdmin/AddReport/ReportTable";
import MandalAdminUpdateReport from "../Pages/MandalAdmin/AddReport/UpateReport";
import MandalAdminParaSabhaReportTable from "../Pages/MandalAdmin/ParaSabhaReport/ParaSabhaReportTable";
import MandalAdminManageGroup from "../Pages/MandalAdmin/ManageGroup/ManageGroup";
import MandalAdminAddGroup from "../Pages/MandalAdmin/ManageGroup/AddGroup";
import MandalAdminUpdateGroup from "../Pages/MandalAdmin/ManageGroup/UpdateGroup";

// for MandalSubadmin
import MandalSubadminDashboard from "../Pages/MandalSubadmin/MandalSubadminDashboard";
import MandalSubadminMandalTable from "../Pages/MandalSubadmin/MandalDetails/MandalTable";
import MandalSubadminUpdateMandal from "../Pages/MandalSubadmin/MandalDetails/UpdateMandal";
import MAndalSubadminMandalInfo from "../Pages/MandalSubadmin/MandalDetails/MandalInfo";
import MandalSubadminHaribhaktTable from "../Pages/MandalSubadmin/Haribhakt/HaribhaktTable";
import MandalSubadminAddHaribhakt from "../Pages/MandalSubadmin/Haribhakt/AddHaribhakt";
import MandalSubadminUpdateHaribhakt from "../Pages/MandalSubadmin/Haribhakt/UpdateHaribhakt";
import MandalSubadminAttendanceTable from "../Pages/MandalSubadmin/AttendanceTable";
import MandalSubadminAddReport from "../Pages/MandalSubadmin/AddReport/AddReport";
import MandalSubadminReportTable from "../Pages/MandalSubadmin/AddReport/ReportTable";
import MandalSubadminUpdateReport from "../Pages/MandalSubadmin/AddReport/UpdateReport";
import MandalSubadminParaSabhaReportTable from "../Pages/MandalSubadmin/ParaSabhaReport/ParaSabhaReportTable";
import MandalSubAdminManageGroup from "../Pages/MandalSubadmin/ManageGroup/ManageGroup";
import MandalSubAdminAddGroup from "../Pages/MandalSubadmin/ManageGroup/AddGroup";
import MandalSubAdminUpdateGroup from "../Pages/MandalSubadmin/ManageGroup/UpdateGroup";

// for SamparkAdmin
import SamparkAdminDashboard from "../Pages/SamparkAdmin/SamparkAdminDashboard";
import SamparkAdminHaribhaktTable from "../Pages/SamparkAdmin/Haribhakt/HaribhaktTable";
import SamparkAdminUpdateHaribhakt from "../Pages/SamparkAdmin/Haribhakt/UpdateHaribhakt";

// for AttendanceWorker
import AttendanceWorkerDashboard from "../Pages/AttendanceWorker/AttendanceWorkerDashboard";
import TakeAttendanceTable from "../Pages/AttendanceWorker/TakeAttendanceTable";
import AttendanceWorkerRegisterHaribhakt from "../components/AttendanceLayout/Register";
import AttendanceWorkerReportTable from "../Pages/AttendanceWorker/AddReport/ReportTable"
import AttendanceWorkerAddTable from "../Pages/AttendanceWorker/AddReport/AddReport"
import AttendanceWorkerUpdateTable from "../Pages/AttendanceWorker/AddReport/UpdateReport"
import AttendanceWorkerParaSabhaReportTable from "../Pages/AttendanceWorker/ParaSabhaReport/ParaSabhaReportTable";


import RoleLogin from "../components/RoleLogin";

export default function Page() {
  usePageTitle();

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/role-login" element={<RoleLogin />} />
      <Route path="/*" element={<Error />} />


      {/* SuperAdmin Dashboard Pages Starts Here... */}
      <Route path="/manage" element={<ManagePage />} />
      <Route path="/register" element={<Register />} />

      {/* Admin(Under SuperAdmin) CRUD */}
      <Route path="/manage-admin" element={<AdminTablePage />} />
      <Route path="/add-admin" element={<AddAdmin />} />
      <Route path="/update-admin" element={<UpdateAdmin />} />

      {/* Mandal(Under SuperAdmin) CRUD */}
      <Route path="/manage-mandal" element={<MandalTable />} />
      <Route path="/add-mandal" element={<AddMandal />} />
      <Route path="/update-mandal" element={<UpdateMandal />} />
      <Route path="/mandal-info" element={<MandalInfo />} />

      {/* Report(Under SuperAdmin) CRUD */}
      <Route path='/sabha-report' element={<ReportTable />} />
      <Route path='/add-report' element={<AddReport />} />
      <Route path='/update-report' element={<UpdateReport />} />

      {/* ParaSabhaReport(Under SuperAdmin) */}
      <Route path="/parasabha-report" element={<ParaSabhaReportTable />} />

      {/* Haribhakt(Under SuperAdmin) CRUD */}
      <Route path="/manage-haribhakt" element={<HaribhaktTable />} />
      <Route path="/add-haribhakt" element={<AddHaribhakt />} />
      <Route path="/update-haribhakt" element={<UpdateHaribhakt />} />
      <Route path="/deleted-haribhakt" element={<DeletedHaribhakt />} />

      {/* ManageGroup(Under SuperAdmin) */}
      <Route path="/manage-group" element={<ManageGroup />} />
      <Route path="/add-group" element={<AddGroup />} />
      <Route path="/update-group" element={<UpdateGroup />} />

      {/* Attendance(Under SuperAdmin) */}
      <Route path="/attendance" element={<AttendanceTable />} />
      {/* SuperAdmin Dashboard Pages Ends Here... */}

      {/* Admin Dashboard Pages Starts Here... */}
      <Route path="/admin-dashboard" element={<AdminDashboard />} />

      {/* Mandal(Under Admin) CRUD */}
      <Route path="/manage-mandal1" element={<AdminMandalTable />} />
      <Route path="/add-mandal1" element={<AdminAddMandal />} />
      <Route path="/update-mandal1" element={<AdminUpdateMandal />} />
      <Route path="/mandal-info1" element={<AdminMandalInfo />} />

      {/* Haribhakt(Under Admin) CRUD */}
      <Route path="/manage-haribhakt1" element={<AdminHaribhaktTable />} />
      <Route path="/add-haribhakt1" element={<AdminAddHaribhakt />} />
      <Route path="/update-haribhakt1" element={<AdminUpdateHaribhakt />} />

      {/* ManageGroup(Under Admin) */}
      <Route path="/manage-group1" element={<AdminManageGroup />} />
      <Route path="/add-group1" element={<AdminAddGroup />} />
      <Route path="/update-group1" element={<AdminUpdateGroup />} /> 

      {/* ParaSabhaReport(Under Admin) */}
      <Route path="/parasabha-report1" element={<AdminParaSabhaReportTable />} />

      {/* Report(Under Admin) CRUD */}
      <Route path='/sabha-report1' element={<AdminReportTable />} />
      <Route path='/add-report1' element={<AdminAddReport />} />
      <Route path='/update-report1' element={<AdminUpdateReport />} />

      {/* Attendance(Under Admin) */}
      <Route path="/attendance1" element={<AdminAttendanceTable />} />
      {/* Admin Dashboard Pages Ends Here... */}


      {/* MandalAdmin Dashboard Pages Starts Here... */}
      <Route path="/mandal-admin-dashboard" element={<MandalAdminDashboard />} />

      {/* Mandal(Under MandalAdmin) CRUD */}
      <Route path="/manage-mandal2" element={<MandalAdminMandalTable />} />
      <Route path="/update-mandal2" element={<MandalAdminUpdateMandal />} />
      <Route path="/mandal-info2" element={<MandalAdminMandalInfo />} />

      {/* Haribhakt(Under MandalAdmin) CRUD */}
      <Route path="/manage-haribhakt2" element={<MandalAdminHaribhaktTable />} /> 
      <Route path="/add-haribhakt2" element={<MandalAdminAddHaribhakt />} />
      <Route path="/update-haribhakt2" element={<MandalAdminUpdateHaribhakt />} />

      {/* ManageGroup(Under MandalAdmin) */}
      <Route path="/manage-group2" element={<MandalAdminManageGroup />} />
      <Route path="/add-group2" element={<MandalAdminAddGroup />} />
      <Route path="/update-group2" element={<MandalAdminUpdateGroup />} />
      
      {/* SabhaReport (Under MandalAdmin) */}
      <Route path='/sabha-report2' element={<MandalAdminReportTable />} />
      <Route path='/add-report2' element={<MandalAdminAddReport />} />
      <Route path='/update-report2' element={<MandalAdminUpdateReport />} />

      {/* ParaSabhaReport(Under MandalAdmin) */}
      <Route path="/parasabha-report2" element={<MandalAdminParaSabhaReportTable />} />

      {/* Attendance(Under MandalAdmin) */}
      <Route path="/attendance2" element={<MandalAdminAttendanceTable />} />
      {/* MandalAdmin Dashboard Pages Ends Here... */}

      {/* MadnalSubadmin Dashboard Pages Starts Here... */}
      <Route path="/mandal-subadmin-dashboard" element={<MandalSubadminDashboard />} />

      {/* Mandal(Under MandalSubadmin) CRUD */}
      <Route path="/manage-mandal3" element={<MandalSubadminMandalTable />} />
      <Route path="/update-mandal3" element={<MandalSubadminUpdateMandal />} />
      <Route path="/mandal-info3" element={<MAndalSubadminMandalInfo />} />

      {/* Haribhakt(Under MandalSubadmin) CRUD */}
      <Route path="/manage-haribhakt3" element={<MandalSubadminHaribhaktTable />} /> 
      <Route path="/add-haribhakt3" element={<MandalSubadminAddHaribhakt />} />
      <Route path="/update-haribhakt3" element={<MandalSubadminUpdateHaribhakt />} />

      {/* ManageGroup(Under MandalSubAdmin) */}
      <Route path="/manage-group3" element={<MandalSubAdminManageGroup />} />
      <Route path="/add-group3" element={<MandalSubAdminAddGroup />} />
      <Route path="/update-group3" element={<MandalSubAdminUpdateGroup />} />      

      {/* SabhaReport (Under MandalSubAdmin) */}
      <Route path='/sabha-report3' element={<MandalSubadminReportTable />} />
      <Route path='/add-report3' element={<MandalSubadminAddReport />} />
      <Route path='/update-report3' element={<MandalSubadminUpdateReport />} />

      {/* ParaSabhaReport(Under MandalSubAdmin) */}
      <Route path="/parasabha-report3" element={<MandalSubadminParaSabhaReportTable />} />      

      {/* Attendance(Under MandalSubAdmin) */}
      <Route path="/attendance3" element={<MandalSubadminAttendanceTable />} />
      {/* MandalSubadmin Dashboard Pages Ends Here... */}

      {/* SamparkAdmin Dashboard Pages Starts Here... */}
      <Route path="/sampark-admin-dashboard" element={<SamparkAdminDashboard />} />

      {/* Haribhakt(Under SamparkAdmin) CRUD */}
      <Route path="/manage-haribhakt4" element={<SamparkAdminHaribhaktTable />} /> 
      <Route path="/update-haribhakt4" element={<SamparkAdminUpdateHaribhakt />} />
      {/* SamparkAdmin Dashboard Pages Ends Here... */}
      
      {/* AttendanceWorker Dashboard Pages Starts Here... */}
      <Route path="/register-haribhakt" element={<AttendanceWorkerRegisterHaribhakt />} />
      <Route path="/attendance-worker-dashboard" element={<AttendanceWorkerDashboard />} />
      <Route path="/take-attendance" element={<TakeAttendanceTable />} />

      {/* SabhaReport (Under AttendanceWorker) */}
      <Route path='/sabha-report4' element={<AttendanceWorkerReportTable />} />
      <Route path='/add-report4' element={<AttendanceWorkerAddTable />} />
      <Route path='/update-report4' element={<AttendanceWorkerUpdateTable />} />

      {/* ParaSabhaReport(Under AttendanceWorker) */}
      <Route path="/parasabha-report4" element={<AttendanceWorkerParaSabhaReportTable />} />    

      {/* AttendanceWorker Dashboard Pages Ends Here... */}

    </Routes>
  );
}
